import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

const DEFAULT_MAX_WIDTH = 800;

/**
 * Блок «Пользовательский Markdown». HTML готовит бэкенд из props.text
 * (site ArenaPageBlock.props), здесь только вывод и типографика:
 * в markdown бывают картинки, таблицы, код и цитаты, которые без стилей
 * вылезают за ширину блока или сливаются с текстом.
 */
export default function ArenaMarkdown(props) {
  const { variant, color, html, paddingTop, paddingBottom, maxWidth } = props;

  if (!html) return null;

  return (
    <Typography
      variant={variant}
      color={color}
      component="div"
      // Без заданной ширины текст тянулся на весь экран: по умолчанию
      // ограничиваем удобной для чтения колонкой по центру
      style={{
        paddingTop,
        paddingBottom,
        maxWidth: maxWidth || DEFAULT_MAX_WIDTH,
        margin: "auto",
      }}
      sx={{
        overflowWrap: "anywhere",
        "& img, & video, & iframe": {
          maxWidth: "100%",
          height: "auto",
        },
        "& a": {
          color: "inherit",
          textDecoration: "underline",
        },
        "& table": {
          display: "block",
          maxWidth: "100%",
          overflowX: "auto",
          borderCollapse: "collapse",
        },
        "& th, & td": {
          border: "1px solid",
          borderColor: "divider",
          padding: "4px 8px",
        },
        "& pre": {
          maxWidth: "100%",
          overflowX: "auto",
          padding: 1,
          borderRadius: 1,
          backgroundColor: "action.hover",
        },
        "& blockquote": {
          margin: 0,
          paddingLeft: 2,
          borderLeft: "4px solid",
          borderColor: "divider",
        },
      }}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}

ArenaMarkdown.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  html: PropTypes.string,
  arena: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};
